import { useNavigate } from "react-router-dom";
import { ShieldOff, Home } from "lucide-react";

export default function ForbiddenPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4">
      <div className="text-center">
        <div className="inline-block p-4 bg-red-100 rounded-full">
          <ShieldOff className="w-16 h-16 text-red-500" />
        </div>
        <h1 className="text-9xl font-bold text-gray-800 mt-4">403</h1>
        <h2 className="text-2xl font-semibold text-gray-600 mt-4">
          访问被拒绝
        </h2>
        <p className="text-gray-500 mt-2">抱歉，您没有权限访问此页面</p>
        <button
          onClick={() => navigate("/")}
          className="mt-8 px-6 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 inline-flex items-center"
        >
          <Home className="w-4 h-4 mr-2" />
          返回首页
        </button>
      </div>
    </div>
  );
}
